module.exports = __webpack_public_path__ + "static/media/motionlogo.f2ebb4f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/motionlogo.mp4
// module id = PThn
// module chunks = 1